import { Navigate, useLocation } from "react-router-dom";
import storage from "../utils/storage";

// 定义白名单路由（未登录状态下可以访问的页面）
const whiteList = ["/Breeding/home", "/Breeding/home/"];

const auth = (Comp) => {
  return () => {
    const { pathname } = useLocation();
    const token = storage.getItem("access_token");
    
    // 如果在白名单中，直接允许访问
    if (whiteList.includes(pathname)) {
      return <Comp />;
    }
    
    // 不在白名单中，需要验证登录状态
    if (!token) {
      return <Navigate to="/login" />;
    }

    // 已登录用户可以访问所有页面
    return <Comp />;
  };
};
export default auth;
